import { render, staticRenderFns } from "./video.vue?vue&type=template&id=0913c0dd&scoped=true"
import script from "./video.vue?vue&type=script&lang=ts"
export * from "./video.vue?vue&type=script&lang=ts"
import style0 from "./video.vue?vue&type=style&index=0&id=0913c0dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0913c0dd",
  null
  
)

export default component.exports